import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 
  MapPin,
  Layers,
  CheckCircle2,
  Circle,
  Trash2,
  Package         
} from "lucide-react";
import { faTruck ,faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const awardsData = [
  {
    id: 1,
    isAwarded: true,
    companyName: "Sai Enterprises",
    contactPerson: "Hari",
    phone: "9533984542",
    location: "Gurunanak Colony Road",
    Type: "Sai Enterprises",
    itemsCount: 4,
    amount: 5350,
    requestDate: "20 Dec 2025",
    requestTime: "07:14:35 PM"
  },
  {
    id: 2,
    isAwarded: false,
    companyName: "Dwaraka Enterprises",
    contactPerson: "Prasad",
    phone: "9845123678",
    location: "Benz Circle",
    Type: "Brickbucket",
    itemsCount: 3,
    amount: 5400,
    requestDate: "20 Dec 2025",
    requestTime: "07:14:35 PM"
  }
];

const pricingSummary = {
  subtotal: 10750,
  tax: 1935,
  total: 12685,
  buildcoinsDiscount: 1268
};

/* ================= STEP UI HELPER ================= */
const RenderRFQStepContent = ({activeStep,isStepLoading,customerInfo, rfqItemResponses, setShowPopup, shipmentBlocks, suppliers,
  productCategories,
  selection,
  setSelection,
  isCategoryFullySelected,
  toggleCategorySelection,
  matrix,
  summary,
 awardedItems,
  vehicles ,
    groups,
  setGroups,
  moveSupplier,
  moveItem,
  groupWeight,
  addGroup,
  paymentDetails,
  onSuccessPayment,
  rfq, 
  finalRfqData,
onOpenAssignSupplier,
 openSupplierResponsePopup ,
 setConfirmDeleteOpen,
 setGroupToDelete
  
}) => {
const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
 const [paymentDate, setPaymentDate] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  /* Mode-specific states */
  const [upiDetails, setUpiDetails] = useState({
    upi_id: "",
    transaction_id: "",
    payer_name: ""
  });

  const [cardDetails, setCardDetails] = useState({
    last_four_digits: "",
    card_type: "",
    transaction_id: ""
  });

  const [bankDetails, setBankDetails] = useState({
    from_account: "",
    to_account: "",
    ifsc_code: "",
    transaction_reference: ""
  });

  const [gatewayDetails, setGatewayDetails] = useState({
    gateway_name: "",
    gateway_transaction_id: "",
    gateway_payment_id: "",
    gateway_order_id: ""
  });


 // console.log("summary:::",summary);

  if (isStepLoading) {
  return (
    <div className="flex flex-col justify-center items-center h-[60vh]">
      <div className="w-14 h-14 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
      <p className="mt-4 text-gray-600 text-sm font-medium">Loading...</p>
    </div>
  );
}

const handleAddDeliveryCharge = ()=>{
    if(!groups.length > 0)return 0
   let  DeliveryCHarge = 0
   groups.forEach(element => {
    DeliveryCHarge += Number(element.deliveryCharge);
});

return DeliveryCHarge
}



const formatAmount = (value) => {
  if (!value) return "--";
  return Number(value).toLocaleString("en-US");
};

const handleSavePayment = async () => {
  try {
    const rfqid = rfq?.rfq_id;
    if (!paymentDate ) {
      alert("Payment date, is required");
      return;
    }
    if ( !paymentMode) {
      alert("Payment mode, is required");
      return;
    }
    if ( !amount) {
      alert("Payment amount is required");
      return;
    }

    setLoading(true);

    const payload = {
      payment_date: paymentDate,
      payment_mode: paymentMode,
      amount: Number(amount),
      description,
      rfq_id: rfqid,
      order_id: rfq?.quotation_id,
      customer_id: customerInfo?.customer?._id,
      organizationId: customerInfo?.customer?.organizationId || '',
    };

    console.log("payload:::::",payload);
 

    if (paymentMode === "UPI") payload.upi_details = upiDetails;
    if (paymentMode === "Card") payload.card_details = cardDetails;
    if (["Bank Transfer", "Cheque"].includes(paymentMode)) {
      payload.bank_transfer_details = bankDetails;
    }
    if (paymentMode === "Gateway") payload.gateway_details = gatewayDetails;


    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/process-customer-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Payment creation failed");
    }
    toast.success("Payment saved successfully", data);
    onSuccessPayment();

  } catch (error) {
    console.error("Failed to save payment:", error);
    alert(error.message || "Failed to save payment");
  } finally {
    setLoading(false);
  }
};


// Group items by product category (only when finalRfqData exists)
const groupedItems =
  finalRfqData &&
  Array.isArray(finalRfqData.items) &&
  Array.isArray(finalRfqData.product_categories)
    ? finalRfqData.items.reduce((acc, item) => {
        const category =
          finalRfqData.product_categories.find(
            (c) => c._id === item.product_category_id
          )?.product_category_name || "Others";

        if (!acc[category]) acc[category] = [];
        acc[category].push(item);

        return acc;
      }, {})
    : {};



  // STEP 1: RFQ PLACED
  if (activeStep === 1) {
  return (
    <div className=" rounded-md  p-6 space-y-6">
      {/* TOP ROW - 3 ROUNDED CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

  {/* 1. RFQ DETAILS */}
  <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-md p-4 border border-green-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-green-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">RFQ Details</h3>
    </div>

    <div className="text-sm space-y-2">
      {/* ROW 1 */}
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">RFQ No:</span>{customerInfo?.rfq_number}</span>
        <span><span className="font-semibold text-gray-700">Status:</span>{customerInfo?.order_status}</span>
      </div>

      {/* ROW 2 */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-700">Total Items:</span>
          <span className="bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full text-xs font-medium">{customerInfo?.items_summary?.total_requested}</span>
        </div>
      </div>
    </div>
  </div>

  {/* 2. CUSTOMER INFO */}
  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-md p-4 border border-blue-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-blue-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">Customer Info</h3>
    </div>

    <div className="text-sm space-y-2">
      {/* ROW 1 */}
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">Name:</span> {customerInfo?.customer?.name}</span>
        <span><span className="font-semibold text-gray-700">Mobile:</span>{customerInfo?.customer?.mobile}</span>
      </div>

      {/* ROW 2 */}
      <div>
        <span className="font-semibold text-gray-700">Company:</span> {customerInfo?.customer?.company_name}
      </div>
    </div>
  </div>

  {/* 3. PROJECT INFO */}
  <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-md p-4 border border-purple-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-purple-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">Delivery Details</h3>
    </div>

    <div className="text-sm space-y-1">
      {/* ROW 1 */}
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">Project Name:</span> {customerInfo?.project?.name}</span>

      </div>
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">Area:</span>{customerInfo?.delivery_address?.area}</span>
       <span><span className="font-semibold text-gray-700">City:</span> {customerInfo?.delivery_address?.city}</span>
      </div>
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">State:</span> {customerInfo?.delivery_address?.state}</span>
       <span><span className="font-semibold text-gray-700">Pincode:</span> {customerInfo?.delivery_address?.pincode}</span>
      </div>
    </div>
  </div>

</div>


      {/* ITEMS TABLE */}
{rfqItemResponses?.length > 0 && (
  <div className="bg-white rounded-md border border-gray-200">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Item Image</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Item Name</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">RFQ Price</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Quantity</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Response</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Final/Best Price</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase">Price Given By</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {rfqItemResponses?.map((item) => (
            <tr key={item.item_id} className="bg-white">
              {/* Item Image */}
              <td className="px-6 py-4">
                {item.item_image ? (
                  <img
                    src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.item_image}
                    alt={item.item_name}
                    className="w-12 h-12 rounded-md object-cover"
                  />
                ) : (
                  <div className="w-12 h-12 bg-gray-200 rounded-md flex items-center justify-center">
                    <svg
                      className="w-6 h-6 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                      />
                    </svg>
                  </div>
                )}
              </td>

              {/* Item Name */}
              <td className="px-6 py-4 text-sm font-medium text-gray-900">
                {item.item_name}
              </td>
             
              {/* RFQ Price */}
              <td className="px-6 py-4 text-sm text-gray-700">
                {item.requested_price}
              </td>

              {/* Quantity */}
              <td className="px-6 py-4 text-sm text-gray-700">
                {item.quantity}
              </td>

              {/* Responses */}
             <td
 className="px-6 py-4 text-sm text-blue-600 cursor-pointer
             underline underline-offset-1
             hover:text-blue-800 hover:decoration-1"
 onClick={openSupplierResponsePopup}
 >
  {item.response_summary.accepted + item.response_summary.counter_offers}
  /
  {item.response_summary.total_responded}
</td>

              {/* Best Price */}
              <td className="px-6 py-4 text-sm font-semibold text-emerald-600">
                {item.final_price ?? '--'}
              </td>

              {/* Price Given By */}
              <td className="px-6 py-4 text-sm font-medium text-gray-900">
                {item?.best_vendor?.company_name ?? '--'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

    </div>
  );
}

// STEP 2: SUPPLIER RESPONSES
if (activeStep === 2) {
  // Assuming we have supplierResponses with similar structure to AdminAwardDecision's suppliers
  // If not, you may need to fetch or map the data accordingly.
  // For this example, I'll assume supplierResponses is an array of suppliers with response_items.

  return (
    <>

     <div className="flex justify-end mb-3 mr-4">
  <button
    className="btn btn-primary text-blue-500 font-medium"
onClick={onOpenAssignSupplier} >
     + Assign Supplier
  </button>
</div>
<div className="bg-white rounded-xl mt-4 mx-4 shadow border flex flex-col">

        {/* ===================== HORIZONTAL SCROLL WRAPPER ===================== */}
<div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-300px)] relative ">
          {/* This container guarantees SAME WIDTH for header + body */}
          <div
            className="min-w-max"
            style={{
              width: 280 + suppliers.length * 220
            }}
          >
            {/* ===================== STICKY HEADER ===================== */}
            <div
              className="sticky top-0 z-20 bg-gray-100 text-[#00000] grid border-b border-gray-100"
              style={{
                gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
              }}
            >
              {/* Items Header */}
             <div className="px-4 py-4 font-semibold h-[64px] flex items-center sticky  left-0 bg-gray-100 z-30 border-r">
                    Items
                  </div>

              {/* Supplier Headers */}
              {suppliers.map(s => (
                <div
                  key={s.vendor_id}
                  className="h-[64px] flex flex-col items-center justify-center px-3 text-center"
                >
                  <div className="text-sm font-medium truncate max-w-[180px]">
                    {s.company_name || s.name}
                  </div>
                  <div className="text-sm  truncate max-w-[180px]">
                    {s.mobile_number}
                  </div>
                  <div className="text-[10px] text-gray-500 font-medium truncate max-w-[180px]">
                    {s.status || s.status}
                  </div>
                  <div className="text-xs text-slate-300 flex items-center gap-1 mt-1">
                    <MapPin size={12} />
                    {s.distanceKm || 0} km
                  </div>
                </div>
              ))}
            </div>

            {/* ===================== BODY (VERTICAL SCROLL) ===================== */}
              {productCategories.map(category => (
                <div key={category.product_category_id} className="border-b">
                  {/* ===================== CATEGORY ROW ===================== */}
                  <div
                    className="bg-white grid items-center border-t"
                    style={{
                      gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
                    }}
                  >
                    <div className="px-4 py-3 font-semibold flex items-center gap-2 sticky left-0 bg-white z-10 border-r">
  <Layers size={16} />
  {category.product_category_name}
  <span className="text-xs text-slate-500">
    ({category.items.length})
  </span>
</div>

                    {suppliers.map(supplier => (
                      <div
                        key={supplier.vendor_id}
                        className="flex justify-center items-center"
                      >
                      {supplier && supplier?.status !== "Respond Now" && (
                        <input
                          type="checkbox"
                          className="w-4 h-4 accent-blue-600"
                          checked={isCategoryFullySelected(
                            category.items,
                            supplier.vendor_id
                          )}
                          onChange={() =>
                            toggleCategorySelection(
                              category.items,
                              supplier.vendor_id,
                              supplier.response_items
                            )
                          }
                        />
                      )}
                      </div>
                    ))}
                  </div>

                  {/* ===================== ITEMS ===================== */}
                  {matrix
                    .filter(row =>
                      category.items.some(
                        i => i.item_id === row.item.item_id
                      )
                    )
                    .map(row => (
                      <div
                        key={row.item.item_id}
                        className="grid border-t"
                        style={{
                          gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
                        }}
                      >
                        {/* Item */}
                       <div className="px-4 py-3 sticky left-0 bg-white z-10 border-r">
  <div className="font-medium">
    {row.item.item_name}
  </div>
  <div className="text-xs text-slate-500">
    Qty {row.item.quantity} • {row.item.UOM}
  </div>
</div>

                        {/* Supplier Prices */}
                        {suppliers.map(supplier => {
                          const price = row.prices.find(
                            p => p.supplierId === supplier.vendor_id
                          );

                          const isSelected =
                            selection[row.item.item_id] ===
                            supplier.vendor_id;

                          const isBest =
                            price &&
                            price.total === row.min &&
                            row.min !== row.max;

                          if (!price) {
                            return (
                              <div
                                key={supplier.vendor_id}
                                className="py-3 text-center text-slate-300"
                              >
                                —
                              </div>
                            );
                          }

                          return (
                            <> 
                             <div
                              key={supplier.vendor_id}
                              className={`py-3 px-2 text-center cursor-pointer transition
                                ${
                                  isSelected
                                    ? "bg-blue-50 border-l-4 border-blue-500"
                                    : "hover:bg-slate-50"
                                }
                              `}
                              onClick={() => { 
                                if (supplier.status === "Respond Now") return; 
                                setSelection(prev => ({
                                  ...prev,
                                  [row.item.item_id]: supplier.vendor_id
                                }))
                              }}
                            >
                              <div className="flex flex-col items-center gap-1">
                                {supplier && supplier?.status !== "Respond Now" && (
                                  <>
                                   {isSelected ? (
                                  <CheckCircle2
                                    size={18}
                                    className="text-blue-600"
                                  />
                                ) : (
                                  <Circle
                                    size={18}
                                    className="text-slate-300"
                                  />
                                )}
                                  </>  
                              )}

                                <div className="text-xs">
                                  ₹{price.unitPrice} × {row.item.quantity}
                                </div>
                                <div className="font-medium">
                                  ₹{price.total}
                                  {isBest && (
                                    <span className="ml-2 text-xs text-green-600 font-bold">
                                      Best
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            </>                            
                          );
                        })}
                      </div>
                    ))}
                </div>
              ))}
            
          </div>
        </div>
      </div>

      {/* TOTALS SECTION BELOW THE TABLE, ALIGNED TO THE RIGHT */}
      <div className="flex justify-end mt-4 mx-4">
        <div className="bg-white p-4 rounded-lg shadow border w-80">
          <h4 className="text-lg font-semibold text-gray-800 mb-3">Summary</h4>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-sm text-gray-600">Items Total:</span>
              <span className="font-medium">₹{Number(summary?.itemsTotal || 0).toLocaleString()}</span>
            </div>
            {/* <div className="flex justify-between">
              <span className="text-sm text-gray-600">Delivery Total:</span>
              <span className="font-medium"> ₹{Number(summary?.deliveryTotal || 0).toLocaleString()}</span>
            </div> */}
            <div className="flex justify-between border-t pt-2">
              <span className="text-sm font-semibold text-gray-800">Grand Total:</span>
              <span className="font-bold text-lg text-blue-600"> ₹{Number(summary?.grandTotal || 0).toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

  // STEP 3: DELIVERY SHIPMENTS (YOUR UI)
 if (activeStep === 3) {
  return (
    <>
      {/* SUMMARY CARDS - Updated with real data */}
      <div className="mb-4 mx-4">
        <div className="grid grid-cols-3 gap-8 w-full">
          <div className="bg-white rounded-lg shadow mt-4 px-8 py-4 text-center">
            <p className="text-sm text-gray-500">Total Shipments</p>
            <p className="text-xl font-semibold mt-1">
              {groups.length}
            </p>
          </div>

          <div className="bg-white rounded-lg shadow px-8 mt-4 py-4 text-center">
            <p className="text-sm text-gray-500">Total Items</p>
            <p className="text-xl font-semibold mt-1">
              {awardedItems.length}
            </p>
          </div>

          <div className="bg-white rounded-lg shadow px-8 py-4 mt-4 text-center">
            <p className="text-sm text-gray-500">Delivery Cost</p>
            <p className="text-xl font-semibold mt-1">
              ₹{handleAddDeliveryCharge() || '0'}
            </p>
          </div>
        </div>
      </div>

      {/* ADD DELIVERY BUTTON */}
      <div className="flex justify-end mb-4">
        <button
          onClick={addGroup}
          className="text-blue-600 font-medium mr-6"
        >
          ➕ Add Delivery Group
        </button>
      </div> 

      {/* MAIN CONTAINERS - Using REAL awardedItems data */}
      {groups.length > 0 ? (
        // Show REAL grouping interface when groups exist
        groups.map((group, blockIndex) => (
          <div
            key={group.groupId}
            className="bg-white rounded-md shadow p-4 mx-4 border border-gray-200 mb-6"
          >
            <div className="flex gap-6">
              <div className="w-[80%] pr-2">
                <h3 className="font-semibold mb-4 bg-white flex justify-between items-center">
                  <span>Delivery Group-(DG-{blockIndex + 1})</span>
                  {groups.length > 1 && (
                    <Trash2
                      size={18}
                      className="text-red-500 hover:text-red-700 cursor-pointer"
                      // onClick={() => setGroups(prev => prev.filter(g => g.groupId !== group.groupId))}
                      onClick={() => {
  setGroupToDelete(group.groupId);
  setConfirmDeleteOpen(true);
}}
                    />
                  )}
                </h3>

                {/* SUPPLIERS & ITEMS FROM REAL DATA */}
                {Object.values(group.suppliers).map((shipment, idx) => {
                  // Get real distance from suppliers data
                  const supplierMeta = suppliers.find(
                    s => s.vendor_id?.toString() === shipment.supplierId?.toString()
                  );
                  const distanceKm = supplierMeta?.distanceKm || 0;

                  return (
                    <div key={idx} className="border rounded-md mb-6 overflow-hidden">
                      {/* SUPPLIER HEADER */}
                      <div className="grid grid-cols-[2fr_1fr_1fr_40px_1fr] bg-gray-50 px-4 py-2 font-medium">
                        <p className="font-medium">{shipment.supplierName}</p>
                        <div className="col-span-2 flex items-center justify-center">
                          <span className="text-sm text-gray-500">
                            Distance: {distanceKm} km
                          </span>
                        </div>
                        <div className="border-l" />
                        <select
                          className="text-xs p-1 border rounded w-full"
                          defaultValue=""
                          onChange={(e) => {
                            moveSupplier(shipment, group.groupId, e.target.value);
                            e.target.value = ""; // ✅ RESET DROPDOWN
                          }}
                        >
                          <option value="">Move</option>
                          {groups
                            .filter(g => g.groupId !== group.groupId)
                            .map(g => (
                              <option key={g.groupId} value={g.groupId}>
                                DG-{groups.indexOf(g) + 1} {/* ✅ DG-2 format */}
                              </option>
                            ))}
                        </select>
                      </div>

                      {/* ITEMS HEADER */}
                      <div className="grid grid-cols-[2fr_1fr_1fr_40px_1fr] bg-gray-100 px-4 py-2 text-sm font-medium">
                        <p>Item Name</p>
                        <p>Qty</p>
                        <p>Weight</p>
                        <div className="border-l" />
                      </div>

                      {/* REAL ITEMS */}
                      {shipment.items.map((item, i) => (
                        <div
                          key={i}
                          className="grid grid-cols-[2fr_1fr_1fr_40px_1fr] px-4 py-2 border-t items-center hover:bg-gray-50"
                        >
                          <p className="font-medium">{item.item_name}</p>
                          <p>{item.quantity}</p>
                          <p>{item.totalWeight || 0} kg</p>
                          <div className="border-l h-full" />
                          <select
                            className="text-xs p-1 border rounded w-full"
                            defaultValue=""
                            onChange={(e) => {
                              moveItem(item, group.groupId, e.target.value);
                              e.target.value = ""; // ✅ RESET DROPDOWN
                            }}
                          >
                            <option value="">Move</option>
                            {groups
                              .filter(g => g.groupId !== group.groupId)
                              .map(g => (
                                <option key={g.groupId} value={g.groupId}>
                                  DG-{groups.indexOf(g) + 1} {/* ✅ DG-2 format */}
                                </option>
                              ))}
                          </select>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>

              {/* SIDEBAR WITH REAL DATA */}
              <div className="w-[20%] border-l pl-4 mt-4 space-y-4">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Total Weight</p>
                  <div className="border rounded px-3 py-1 font-semibold">
                    {groupWeight(group.suppliers)} kg
                  </div>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Vehicle</p>
                <select
  className="border rounded px-2 py-1 w-full"
  value={group.vehicleId}
  onChange={(e) =>
    setGroups(prev =>
      prev.map(g =>
        g.groupId === group.groupId
          ? { ...g, vehicleId: e.target.value }
          : g
      )
    )
  }
>
  {vehicles.map(v => (
    <option key={v.type} value={v.type}>
      {v.type}
    </option>
  ))}
</select>

                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Delivery Cost</p>
              <input
  type="number"
  className="border rounded px-2 py-1 w-full"
  value={group.deliveryCharge}
  onChange={(e) =>
    setGroups(prev =>
      prev.map(g =>
        g.groupId === group.groupId
          ? {
              ...g,
              deliveryCharge:
                e.target.value === "" ? "" : Number(e.target.value)
            }
          : g
      )
    )
  }
/>
                </div>
                 <div>
    <p className="text-sm text-gray-500 mb-1">Delivered by Brickbucket</p>
   <select
  className="border rounded px-2 py-1 w-full"
  value={group.deliveredByBrickbucket ?? ""}
  onChange={(e) =>
    setGroups(prev =>
      prev.map(g =>
        g.groupId === group.groupId
          ? { ...g, deliveredByBrickbucket: e.target.value }
          : g
      )
    )
  }
>
  <option value="">Select</option>
  <option value="true">Yes</option>
  <option value="false">No</option>
</select>
  </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        // Show sample layout if no groups (fallback)
        shipmentBlocks.map((block, blockIndex) => (
          <div key={block.id} className="bg-white rounded-md shadow p-4 mx-4 border border-gray-200 mb-6">
            {/* Your existing shipment block JSX */}
          </div>
        ))
      )}

      {/* CONFIRM BUTTON */}
      {/* <div className="flex justify-center mt-8 mx-4">
        <button
          onClick={handleConfirm}
          className="bg-blue-600 text-white px-12 py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-blue-700 transition-all"
        >
          Start Award Process
        </button>
      </div> */}
    </>
  );
}

  // STEP 4: AWARDED
  if (activeStep === 4) {
  return (
    <div className="bg-white mx-1 rounded-xl p-2 space-y-8">
      
      {/* SUPPLIER CARDS - MAPPED FROM DATA */}
    {/*  <div className="space-y-6">   
  {awardsData.map((award, index) => (
    <div 
      key={award.id}
      className="mx-1 bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-6 border border-gray-200  transition-all duration-200"
    >
      
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center mr-3 shadow-md flex-shrink-0">
           <svg
  className="w-5 h-5 text-gray-600"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.7"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M3 22h18M6 22V4h4v18M14 22V8h4v14"
  />
</svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">{award.companyName}</h3>
            <p className="text-sm text-gray-600 mt-1">{award.contactPerson}</p>
          </div>
        </div>
        <span className={`inline-flex items-center px-3 py-1 text-xs font-bold rounded-full shadow-sm ${
          award.isAwarded 
            ? "bg-emerald-100 text-emerald-800" 
            : "bg-gray-100 text-gray-600"
        }`}>
          {award.isAwarded ? " Awarded" : " Not Awarded"}
        </span>
      </div>
      
    
<div className="grid grid-cols-3 gap-4 text-sm mb-4 items-center ml-12">
 
  <div className="flex items-center">
    <svg
      className="w-4 h-4 text-gray-500 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      />
    </svg>
    <span className="font-medium text-gray-900">{award.phone}</span>
  </div>

 
  <div className="flex items-center">
    <svg
      className="w-4 h-4 text-gray-500 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    <span className="font-medium text-gray-900">{award.location}</span>
  </div>


  <div className="flex items-center gap-2">

  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
    <FontAwesomeIcon icon={faTruck} className="text-gray-500 w-5 h-5" />
  </div>
  
  <span className="font-medium text-gray-900 whitespace-nowrap">
    {award.Type}
  </span>
</div>
</div>


      
   <div className="flex items-center justify-between pt-3 border-t border-gray-200 text-sm ml-12">
 
  <a
    href="#"
    className="flex items-center text-emerald-600 hover:text-emerald-700 font-medium underline underline-offset-2"
  >
    <svg
      className="w-4 h-4 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
      />
    </svg>
    {award.itemsCount} Items
  </a>


  <span className="font-bold text-lg text-emerald-600">
    ₹{award.amount.toLocaleString()}
  </span>

  
  <div className="flex items-center text-gray-500">
    <svg
      className="w-3.5 h-3.5 mr-1"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    Requested {award.requestDate} {award.requestTime}
  </div>
</div>


    </div>
  ))}
</div> */}

     <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-gray-700 border rounded-lg">
                  <thead className="bg-gray-100 text-xs uppercase font-semibold">
                    <tr>
                      <th className="px-4 py-3 text-left">Item Image</th>
                      <th className="px-4 py-3 text-left">Item Name</th>
                      <th className="px-4 py-3 text-left">Req. Price</th>
                      <th className="px-4 py-3 text-left">Response</th>
                      <th className="px-4 py-3 text-left">Final / Best Price</th>
                      <th className="px-4 py-3 text-left">Price Given By</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {rfqItemResponses.map((item, index) => {
                      const summary = item?.response_summary || {};
                      const accepted = summary?.accepted || 0;
                      const counter = summary?.counter_offers || 0;
                      const total = summary?.total_responded || 0;
                      const finalPrice =
                        item?.final_price && item.final_price !== "--"
                          ? `₹${item.final_price}`
                          : item?.best_vendor?.proposed_price
                          ? `Best ₹${item?.best_vendor?.proposed_price}`
                          : "--";

                      return (
                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                          <td className="px-4 py-3">
                            {item?.item_image ? (
                              <img
                                src={imageurl + item?.item_image}
                                alt={item?.item_name || "Item"}
                                className="w-12 h-12 object-cover rounded-md border"
                              />
                            ) : (
                              <div className="w-12 h-12 bg-gray-100 flex items-center justify-center rounded-md">
                                <Package className="text-gray-400" size={18} />
                              </div>
                            )}
                          </td>
                          <td className="px-4 py-3">{item?.item_name || "--"}</td>
                          <td className="px-4 py-3">₹{formatAmount(item?.requested_price || 0)}</td>
                          <td className="px-4 py-3">
                            {accepted + counter}/{total}
                          </td>
                          <td className="px-4 py-3">{finalPrice}</td>
                          <td className="px-4 py-3">
                            {item?.awarded_vendor || "Not Available"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

      {/* PRICING SUMMARY - MAPPED FROM DATA */}
     <div className="mx-1 bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-6 border border-gray-200">   
  <h3 className="text-xl font-bold text-gray-900 mb-4">Pricing Summary</h3>
  
  <div className="flex items-end space-x-8 mb-4 text-sm border-b border-gray-200 pb-3">
    <div className="flex-1">
      <span>Subtotal: ₹{formatAmount(customerInfo?.pricing_summary?.final?.subtotal || 0)}</span>
    </div>
    <div className="flex-1">
      <span>Tax Amount: ₹{formatAmount(customerInfo?.pricing_summary?.final?.tax_amount || 0)}</span>
    </div>
    <div className="flex-1">
      <span className="font-bold text-lg">Total: ₹{formatAmount(customerInfo?.pricing_summary?.final?.total || 0)}</span>
    </div>
  </div>
  
  <div className="flex items-center justify-between p-3 bg-blue-50 rounded-xl border border-blue-100 text-xs">
   <span className="font-semibold">Buildcoins Discount: <span className="font-bold">-₹{formatAmount(customerInfo?.pricing_summary?.final?.buildcoins_discount || 0)}</span></span>
    <button 
  className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-all duration-200"
  onClick={() => setShowPopup(true)}
>
  Give Buildcoins
</button>
  </div>
</div>


    </div>
  );
}

 // STEP 5: CUSTOMER PAYMENTS (NEW DESIGN)
if (activeStep === 5) {
  return (
    <div className="bg-white mx-1 rounded-xl  p-2 space-y-8 ">
      
      {/* CUSTOMER INFORMATION CARD */}
     <div className="mx-1 bg-gradient-to-br from-slate-50 via-blue-25 to-indigo-25 rounded-xl p-6 border border-blue-100  transition-all duration-200">
  
  <div className="flex items-center mb-5">
    <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center mr-3 shadow-md flex-shrink-0">
      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>

    <h3 className="text-lg font-semibold text-gray-900">
      Customer Information
    </h3>
  </div>



  
  {/* CUSTOMER DETAILS - SAME LINE LAYOUT */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-sm">
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Company Name</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.company_name || '---'}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Customer Name</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.customer_name || customerInfo?.customer?.name }</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Email</p>
      <p className="font-bold text-md text-blue-600 break-all">{customerInfo?.customer?.email || ''}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Phone</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.customer?.mobile || ''}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Amount</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.pricing_summary?.final?.total || 0}</p>
    </div>
  </div>
</div>


   {/* PAYMENT SECTION */}
{paymentDetails ? (
  /* ================= PAYMENT DETAILS (READ ONLY) ================= */
  <div className="mx-1 bg-gradient-to-br from-emerald-50 to-green-50 rounded-xl p-6 border border-emerald-200 transition-all duration-200">
    <div className="flex items-start mb-8">
      <div className="w-10 h-10 bg-emerald-500 rounded-2xl flex items-center justify-center mr-5 shadow-lg">
        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Payment Details</h3>
        <p className="text-emerald-600 font-semibold text-sm">Successfully Processed</p>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 p-6 bg-white/50 rounded-2xl">
      <div>
        <p className="text-sm font-semibold text-gray-700">Date</p>
        <p className="text-sm font-bold text-gray-900">
          {new Date(paymentDetails.payment_date).toLocaleDateString()}
        </p>
      </div>

      <div>
        <p className="text-sm font-semibold text-gray-700">Amount</p>
        <p className="text-sm font-black text-emerald-600">
          ₹ {paymentDetails.amount}
        </p>
      </div>

      <div>
        <p className="text-sm font-semibold text-gray-700">Payment Method</p>
        <span className="inline-flex px-3 py-1 bg-emerald-100 text-emerald-800 text-sm font-bold rounded-full">
          {paymentDetails.payment_mode}
        </span>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-white/50 rounded-2xl">
      <div>
        <p className="text-xs font-semibold uppercase text-gray-600">Transaction ID</p>
        <p className="text-sm font-medium text-gray-900">
          {paymentDetails?.upi_details?.transaction_id ||
           paymentDetails?.card_details?.transaction_id ||
           paymentDetails?.bank_transfer_details?.transaction_reference ||
           "-"}
        </p>
      </div>

      <div className="text-center">
        <p className="text-xs font-semibold uppercase text-gray-600">Status</p>
        <span className="inline-flex px-3 py-1 bg-emerald-100 text-emerald-800 text-sm font-bold rounded-full">
          {paymentDetails.status || "Paid"}
        </span>
      </div>
    </div>
  </div>
) : (
  /* ================= CREATE PAYMENT FORM ================= */
   <div className="mx-1 bg-white rounded-xl p-6 border border-gray-200">
    <h3 className="text-lg font-semibold mb-4">Create Payment</h3>

    {/* BASIC DETAILS */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <input type="date" className="border p-2 rounded"
        value={paymentDate} onChange={e => setPaymentDate(e.target.value)} />

      <select className="border p-2 rounded"
        value={paymentMode} onChange={e => setPaymentMode(e.target.value)}>
        <option value="">Select Payment Mode</option>
        <option>Cash</option>
        <option>UPI</option>
        <option>Card</option>
        <option>Bank Transfer</option>
        <option>Cheque</option>
        <option>Gateway</option>
      </select>

      <input type="number" placeholder="Amount"
        className="border p-2 rounded"
        value={amount} onChange={e => setAmount(e.target.value)} />
    </div>

    {/* CASH */}
    {paymentMode === "Cash" && (
      <p className="text-sm text-gray-600 mb-4">
        Cash payment received directly from customer.
      </p>
    )}

    {/* UPI */}
    {paymentMode === "UPI" && (
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <input placeholder="UPI ID" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, upi_id: e.target.value })} />
        <input placeholder="Transaction ID" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, transaction_id: e.target.value })} />
        <input placeholder="Payer Name" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, payer_name: e.target.value })} />
      </div>
    )}

    {/* CARD */}
    {paymentMode === "Card" && (
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <input placeholder="Card Type" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, card_type: e.target.value })} />
        <input placeholder="Last 4 Digits" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, last_four_digits: e.target.value })} />
        <input placeholder="Transaction ID" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, transaction_id: e.target.value })} />
      </div>
    )}

    {/* BANK / CHEQUE */}
    {["Bank Transfer", "Cheque"].includes(paymentMode) && (
      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <input placeholder="From Account" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, from_account: e.target.value })} />
        <input placeholder="To Account" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, to_account: e.target.value })} />
        <input placeholder="IFSC Code" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, ifsc_code: e.target.value })} />
        <input placeholder="Transaction / Cheque No" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, transaction_reference: e.target.value })} />
      </div>
    )}

    {/* GATEWAY */}
    {paymentMode === "Gateway" && (
      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <input placeholder="Gateway Name" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_name: e.target.value })} />
        <input placeholder="Gateway Transaction ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_transaction_id: e.target.value })} />
        <input placeholder="Payment ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_payment_id: e.target.value })} />
        <input placeholder="Order ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_order_id: e.target.value })} />
      </div>
    )}

    {/* DESCRIPTION */}
    <textarea rows={3} className="border w-full p-2 rounded mb-4"
      placeholder="Payment description"
      value={description} onChange={e => setDescription(e.target.value)} />

    {/* ACTIONS */}
    <div className="flex justify-end gap-3">
      <button className="border px-4 py-2 rounded">Cancel</button>
      <button disabled={loading}
        onClick={handleSavePayment}
        className="bg-emerald-600 text-white px-5 py-2 rounded">
        {loading ? "Saving..." : "Save Payment"}
      </button>
    </div>
  </div>
)}

    

    </div>
  );
}


// STEP 6: ORDER PLACED
if (activeStep === 6 && finalRfqData) {
  return (
    <div className="p-4 space-y-6">

      {/* ===== SUCCESS HEADER ===== */}
      <div className="flex items-center justify-between rounded-lg mx-1 mt-4 px-4 py-4 shadow-sm border border-gray-200 mb-4">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="text-base font-semibold text-gray-900">
              Order Confirmed
            </h2>
            <span className="text-green-600">
              ✔
            </span>
          </div>
          <p className="text-sm text-gray-600 mt-1">
            Payment received — RFQ converted to Order successfully.
          </p>
        </div>

        <div className="text-right">
          <div className="text-xs text-gray-500 mb-1">Order Number</div>
          <div className="px-3 py-1 border border-green-300 rounded-md bg-green-50">
            <span className="text-sm font-semibold text-green-700">
              {finalRfqData.order_number}
            </span>
          </div>
        </div>
      </div>

      {/* ===== ITEMS BY CATEGORY ===== */}
      {Object.entries(groupedItems).map(([category, items]) => (
        <div
          key={category}
          className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4"
        >
          <h3 className="text-md font-semibold text-gray-800 mb-3">
            {category}
          </h3>

          <div className="space-y-3">
            {items.map((item) => (
              <div
                key={item._id}
                className="flex items-start space-x-3 p-3 bg-white rounded-md border border-gray-200"
              >
                {/* IMAGE */}
                <div className="w-14 h-14 bg-gray-50 rounded-md flex-shrink-0">
                  <img
                    src={imageurl + item.item_image}
                    alt={item.item_name}
                    className="w-full h-full object-contain"
                  />
                </div>

                {/* DETAILS */}
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-gray-900">
                    {item.item_name}
                  </h4>
                  <p className="text-xs text-gray-500">
                    ₹{item.selling_price} × {item.quantity} {item.UOM}
                  </p>
                </div>

                {/* PRICE */}
                <div className="text-right">
                  <div className="text-xs text-gray-400 line-through">
                    ₹{item.item_total_before_savings}
                  </div>
                  <div className="text-lg font-bold text-green-600">
                    ₹{item.item_total_after_savings}
                  </div>

                  {item.earned_build_coins > 0 && (
                    <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs font-medium">
                      +{item.earned_build_coins} BuildCoins
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* ===== BILL SUMMARY ===== */}
      <div className="flex justify-end mt-6">
        <div className="w-[320px]">
          <h3 className="text-md font-semibold text-gray-900 mb-4">
            Bill Summary
          </h3>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Subtotal</span>
              <span className="font-medium">
                ₹{finalRfqData.subtotal}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">Tax</span>
              <span className="font-medium text-purple-600">
                +₹{finalRfqData.tax_amount}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">Discount</span>
              <span className="font-medium text-emerald-600">
                -₹{finalRfqData.discount}
              </span>
            </div>

            <div className="border-t pt-3 flex justify-between">
              <span className="font-semibold">Order Value</span>
              <span className="text-xl font-bold text-emerald-700">
                ₹{finalRfqData.total}
              </span>
            </div>

            <div className="flex justify-between text-xs text-gray-600">
              <span>BuildCoins Earned</span>
              <span>+{finalRfqData.total_earned_build_coins}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}




  // DEFAULT (should not hit)
  return null;
};


export default RenderRFQStepContent